import React, { useState, useEffect } from "react";
import {
  insertOrUpdateFavouritePrompts, removeFavoritePrompt
} from "../../config/apiConfig";
import moment from "moment";
import "./Chatbot.css";
import { sbaAxios } from "../utils/sbaAxios";

function RecentPrompts({ recentPrompts, setInputText, setRecentPrompts, handleFavoriteAdd , favprompts }) {
  const [formattedTimes, setFormattedTimes] = useState({});
  const [isHovered, setIsHovered] = useState(false);

  const updateFormattedTime = (editedTime) => {
    const date = new Date(editedTime); // London time input

    // Convert to US Eastern Time (UTC-5)
    const utcOffset = 5 * 60 * 60 * 1000; // 5 hours in milliseconds
    const usTime = new Date(date.getTime());

    // Time difference in seconds
    const diff = Math.floor((new Date() - usTime) / 1000);

    const minute = 60;
    const hour = 60 * minute;
    const day = 24 * hour;
    const week = 7 * day;
    const month = 30 * day;

    if (diff < minute) return `${diff} s`;
    if (diff < hour) return `${Math.floor(diff / minute)} m`;
    if (diff < day) return `${Math.floor(diff / hour)} h`;
    if (diff < week) return `${Math.floor(diff / day)} d`;
    if (diff < month) return `${Math.floor(diff / week)} w`;
    return `${Math.floor(diff / month)} mo`;
};


  // Update timestamps every 10 seconds
  useEffect(() => {
    // Initialize formatted times
    const initialTimes = {};
    recentPrompts.forEach((prompt) => {
        initialTimes[prompt.promptID] = updateFormattedTime(prompt.edited);
    });
    setFormattedTimes(initialTimes);

    const interval = setInterval(() => {
        const updatedTimes = {};
        recentPrompts.forEach((prompt) => {
            updatedTimes[prompt.promptID] = updateFormattedTime(prompt.edited);
        });
        setFormattedTimes(updatedTimes);
    }, 10000); // Updates every 10 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [recentPrompts]); // Re-run if recentPrompts changes

  const addTOFavourite= async(text,Id)=>{
    const favPromptDto={
        "favouritePromptId": 0,
        "prompt": text,
        "userId": 0,
        "userName": "",
        "isShared": false,
        "sortOrder": 999,
        "createdDate": new Date().toISOString()
      };
      setRecentPrompts(val=>val.map(item=>{
        if(item.promptID==Id)
        {
            item.isFavourite=true
        }
        return item
      }))

      try {
           await sbaAxios({url:insertOrUpdateFavouritePrompts,data:[favPromptDto],method:"post"})
           handleFavoriteAdd();
      } catch (error) {
        
      }
  };

  const removeFavorite = async(text,Id)=>{
    const favPromptItem = favprompts.filter(item => item.Prompt === text);
    const isDefaultFavPrompt = favPromptItem[0].sortOrder < 999 ? true: false;
    
      setRecentPrompts(val=>val.map(item=>{
        if(item.promptID==Id)
        {
            item.isFavourite=false
        }
        return item
      }))

      try {
           const favPromptId = favPromptItem[0].FavouritePromptId;
           if(favPromptId>0 && !isDefaultFavPrompt){
            await sbaAxios({url:`${removeFavoritePrompt}${favPromptId}`, method:"post"});
           }
           handleFavoriteAdd();
      } catch (error) {
        
      }
  };

  const getPromptExistInFavorites=(recent,Favorites)=>{
    try {
        const asal= Favorites.filter(item=>item.Prompt==recent.text);
        return asal.length>0;      
      } catch (error) {
      
    }
  };  
  return (
    <div style={{ height:"50vh", overflowY:"scroll"}}>
      <ul className="recent-list p-0">
        {recentPrompts
        .slice()
        .sort((a, b) => new Date(b.edited) - new Date(a.edited))
        .map((prompt, index) => (
          <li
            key={index}
            className="menu-item recent-item p-2"
            style={{
              cursor: "pointer",
              boxShadow: isHovered==index ? "0px 4px 8px rgba(0, 0, 0, 0.2)" : "none",
            }}
            onMouseEnter={() => setIsHovered(index)}
            onMouseLeave={() => setIsHovered(null)}
          >
            <div className="d-flex justify-content-between align-items-center" style={{textWrap:"nowrap"}}>
              {/* Prompt text */}
              <p
                className={isHovered==index ?"prompt-text w-75  text-wrap" : "prompt-text w-75  text-truncate"}
                onClick={() => {
                  // const targetElement = document.querySelector(
                  //   `div.p-3.bg-white.life-science.rounded.mt-2#${prompt.promptID}`
                  // );
                  const targetElement = document.getElementById(prompt.promptID);
              
                  if (targetElement) {
                    targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
                  } else {
                    setInputText(prompt.text);
                  }
                }}
                style={{overflowX: 'hidden'}}
                title={prompt.text}
              >
                {prompt.text}
              </p>
              <>{
               
                <div> 
                  {prompt.status ? <>  <img style={{
                    display: "inline-block",
                    animation: prompt.isProcessing && "rotateInfinite 2s linear infinite",
                  }} src={!prompt.isProcessing ? "/images/completedCheck.svg" : "/images/pendingHourGlass.svg"} />
                </> : <>
                <img style={{
                    display: "inline-block",
                  }} src={ "/images/closeIcon.svg"} />
                  </>}
                </div>
              }</>
              {/* Show time or star based on hover */}
              {isHovered!=null ? (
               <i
               className={`fa-solid fa-star ${
                 getPromptExistInFavorites(prompt,favprompts) ? "text-warning" : "text-SBATheme"
               }`}
               style={{marginLeft:'5px'}}
               title={
                 getPromptExistInFavorites(prompt,favprompts)
                   ? "Added to Favorite"
                   : "Add to Favorite"
               }
               onClick={() => {
                if (getPromptExistInFavorites(prompt, favprompts)) {
                    removeFavorite(prompt.text, prompt.promptID);
                } else {
                  addTOFavourite(prompt.text, prompt.promptID);
                }
            }}
             ></i>
              ) : (
                <span className="timestamp" style={{marginLeft:'5px'}}>
                  {formattedTimes[prompt.promptID]}
                </span>
              )}
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default RecentPrompts;
